module.exports = __webpack_public_path__ + "img/Valiant-Rescuer-Ikoria-MtG-Art.56e5e224.jpg";